import { render } from "./ExtraFieldsManager.vue?vue&type=template&id=60b25f64&scoped=true"
import script from "./ExtraFieldsManager.vue?vue&type=script&lang=js"
export * from "./ExtraFieldsManager.vue?vue&type=script&lang=js"

import "./ExtraFieldsManager.vue?vue&type=style&index=0&id=60b25f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b25f64"]])

export default __exports__